
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"40","height":"40","rx":"20","fill":"#FFA0DD"}}),_c('path',{attrs:{"d":"M30.246 13.75c-.242 0-.488.07-.71.223l-4.286 2.671v-2.277c0-1.031-.906-1.867-2.023-1.867H11.023C9.906 12.5 9 13.336 9 14.367v11.266c0 1.031.906 1.867 2.023 1.867h12.204c1.117 0 2.023-.836 2.023-1.867v-2.277l4.285 2.667c.223.157.473.223.711.223.649 0 1.254-.508 1.254-1.23V14.98c0-.723-.605-1.231-1.254-1.231zm-6.871 4.063v7.769a.255.255 0 01-.148.043H11.023a.229.229 0 01-.148-.043V14.418a.255.255 0 01.148-.043h12.204c.078 0 .125.023.148.043v3.395zm6.25 6.062l-4.375-2.727v-2.293l4.375-2.726v7.746z","fill":"#0B0E1F"}})])
          )
        }
      }
    